<template>
  <div id="app" 
  :style="{'background-image': 'url(' + require(`./assets/images/login/${businessBack}`) + ')'}"
  >
    <v-app>
      <LoginMaster msg="Welcome to Your Vue.js App"/>
    </v-app>
    </div>
</template>

<script>
import LoginMaster from './components/LoginMaster.vue'

export default {
  name: 'App',
  data() {
    return {
      businessBack: process.env.VUE_APP_BUSINESS_BACK
    }
  },  
  components: {
    LoginMaster
  },
  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    console.log(urlParams.get('redirect') != 1);
    if(urlParams.get('redirect') != 1){
      if (this.isValidCookies()) {
        const frontendUrl = this.$cookies.get('frontendUrl')
        if(frontendUrl){
          window.location.href = frontendUrl;
        }
      }
    } else {
      this.clearCookies();

      if(this.$cookies.get('frontendUrl')){
       // this.$cookies.remove('frontendUrl');
        window.location = window.location.href.replace('?redirect=1', '#');
        // console.log('location ', window.location);
        window.location.reload();
      }
    }
  }, 
  methods:{
    isValidCookies: function(){
      const frontendUrl = this.$cookies.get('frontendUrl');
      const BackendUrl = this.$cookies.get('BackendUrl');
      const tokenMaster = this.$cookies.get('tokenMaster');
      /*
        Agregar al IF cuando actualicen todos los frontend
        || !BackendUrl || BackendUrl.length < 1 
        || !tokenMaster || tokenMaster.length < 1 
       */
      if (!frontendUrl || frontendUrl.length < 1) {
            console.warn(`No se encontraron las cookies necesarias F/B/T`, frontendUrl, BackendUrl, tokenMaster);
            
        this.clearCookies();
        return false;
      }
      return true;
    },
    clearCookies: function(){
      console.info('Clear cookies');
      const domain = window.location.hostname;
      this.$cookies.remove('frontendUrl', '/', domain);
      this.$cookies.remove('BackendUrl', '/', domain);
      this.$cookies.remove('tokenMaster', '/', domain);
      
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
</style>
